module.exports = "pegasus/assets/l_w.png";